let getUrlObject = (urls, instancename, urlname, action) => {
  /**
   * Вспомогательная функция для получения объекта URL по параметрам
   * @param {Object} urls - Объект со всеми URL-шаблонами
   * @param {string} instancename - Имя экземпляра
   * @param {string} urlname - Имя URL-шаблона
   * @param {string} action - HTTP-метод действия
   * @returns {Object|null} Объект URL-шаблона или null, если не найден
   */
    return urls[instancename]
        .find(x => x.name === urlname).methods
        .find(x => x.action === action)
};

const state = {
    urls: {},
};

const mutations = {
    appendUrls(state, urls) {
      /**
       * Добавляет новые URL-шаблоны в состояние
       * @param {Object} urls - Новые URL-шаблоны для добавления
       */
        let new_keys = Object.keys(urls);
        let existed_keys = Object.keys(state.urls);
        for (let i in new_keys) {
            if (!(new_keys[i] in existed_keys)) {
                state.urls[new_keys[i]] = urls[new_keys[i]];
            }
        }
    },
    clearUrls(state) {
      /**
       * Очищает все URL-шаблоны
       */
        state.urls = {};
    }
};


const getters = {
    getInstance: (state) => (instance) => {
      /**
       * Получает все URL-шаблоны для указанного экземпляра
       * @returns {Function} Функция, принимающая имя экземпляра и возвращающая его URL-шаблоны
       */
        try {
            let urls = state.urls[instance];
            urls.getUrl = function (name) {
                return this[name];
            };
            return urls;
        } catch (e) {
            return {};
        }
    },

    getPattern: (state) => (instancename, urlname, action) => {
      /**
       * Получает URL-шаблон для указанных параметров
       * @returns {Function} Функция, принимающая параметры и возвращающая шаблон URL
       */
        try {
            return getUrlObject(state.urls, instancename, urlname, action).pattern
        } catch (e) {
            return ''
        }
    },


    getAllowed: (state) => (instancename, urlname, action) => {
      /**
       * Проверяет, разрешен ли доступ к endpoint'у
       * @returns {Function|null} Функция, принимающая параметры и возвращающая boolean
       */
        try {
            return getUrlObject(state.urls, instancename, urlname, action).allowed;
        } catch (e) {
            return ''
        }
    },

    getUrl: (state) => (instancename, urlname, action) => {
      /**
       * Получает полный объект URL-шаблона
       * @returns {Function|null} Функция, принимающая параметры и возвращающая объект URL
       */
        try {
            return getUrlObject(state.urls, instancename, urlname, action);
        } catch (e) {
            return null
        }
    },

    checkAlreadyLoaded: (state) => (instancename) => {
      /**
       * Проверяет, загружены ли URL-шаблоны для экземпляра
       * @returns {boolean} Если имя экземпляра есть в URL-шаблоне true иначе false
       */
        if (instancename in state.urls)
            return true;
        return false;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
}
